import { AbstractPopUp, AbstractPopUpParams } from './AbstractPopUp';
import { PopUpName } from '../core/managers/PopUpManager';
import { Button } from '../UI/elements/buttons/Button';
import { translate } from '../utils/GameEngine';

export interface ConfirmPopUpParams extends AbstractPopUpParams {
    callback: () => any;
    text: string;
    text2?: string;
    image?: string;
    noDiscardButton?: boolean;
    confirmButtonLabel?: string;
}

export class ConfirmPopUp extends AbstractPopUp {
    protected confirmButton: Button;
    protected discardButton: Button;

    constructor(public readonly name: PopUpName, public params: ConfirmPopUpParams) {
        super(name, params);
    }

    protected drawLayout(params: any): void {
        super.drawLayout(params);
        this.drawButtons();
    }

    protected drawButtons(): void {
        this.confirmButton = new Button(
            'green_btn_small@2x',
            (): void => {
                this.params.callback();
                this.hide(true);
            },
            translate(this.params.confirmButtonLabel || 'Yes', true),
            true,
            true,
            1
        );
        this.addChild(this.confirmButton);
        this.confirmButton.position.x = this.background.width / 2;
        this.confirmButton.position.y = this.buttonY;

        if (!this.params.noDiscardButton) {
            this.discardButton = new Button(
                'red_btn_small@2x',
                (): void => {
                    this.hide(true);
                },
                translate('No', true),
                true,
                true,
                1);
            this.addChild(this.discardButton);
            this.discardButton.position.set(this.background.width * 0.66, this.buttonY);
            this.confirmButton.position.set(this.background.width * 0.33, this.buttonY);
        }
    }
}